// src/components/Header.jsx
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import { AuthContext } from '../contexts/AuthContext';
import '../css/header.css';

const Header = ({ sidebarOpen, toggleSidebar, onlyHamburger }) => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="header-container">
      <div className="header-left">
        <button
          className={`header-hamburger ${!onlyHamburger ? 'mobile-only' : ''}`}
          onClick={toggleSidebar}
        >
          {sidebarOpen 
            ? <i className="fas fa-times" />
            : <i className="fas fa-bars" />
          }
        </button>
      </div>

      <div className="header-center">
        <img
          src={logo}
          alt="Logo"
          className="header-logo"
          onClick={() => navigate('/dashboard')}
          style={{ cursor: 'pointer' }}
        />
      </div>

      {user && (
        <div className="header-right">
          <div className="account-container">
            <div className="user-details">
              <div className="name-row">
                <i className="fas fa-user-circle icon-user" />
                <span className="user-fullname">{user.fullName}</span>
              </div>
              {/* <div className="email-row">
                <i className="fas fa-envelope icon-mail" />
                <span className="user-email">{user.email}</span>
              </div> */}
            </div>
            <button className="btn-logout" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
